angular.module('SpidApp')

.filter('capitalize', function () {
    return function (input) {
        if (!input || input.length === 0) {
            return ''
        }

        if (input.length === 1) {
            return input[0].toUpperCase()
        }

        return input[0].toUpperCase() + input.substr(1)
    }
})
